<template>
    <SignaloDialog
        :open="dialogOpened"
        @close="closeDialog"
        :title="$t('common.crew')"
    >
        <template #body>
            <v-form ref="form" v-model="dataValid" lazy-validation>
                <v-col cols="12" md="12" xl="12">
                    <SignaloTranslatableTabs
                        v-slot="{ value, update }"
                        v-model="name"
                        :currentLanguage="$i18n?.locale"
                        :availableLocales="getAvailableLocales()"
                    >
                        <v-text-field
                            :label="$t('common.name')"
                            :modelValue="value"
                            @update:modelValue="update"
                            :rules="required"
                            required
                            variant="outlined"
                            color="var(--greyscale-100)"
                            class="required-field"
                        >
                        </v-text-field>
                    </SignaloTranslatableTabs>
                </v-col>
                <v-col cols="12" md="12" xl="12">
                    <SignaloNewValueSelect
                        :selectableType="SELECTABLE_TYPES.SHIFT_SCHEMA"
                        v-model="shift_schema_id"
                        clearable
                        required
                    />
                </v-col>
            </v-form>
        </template>
        <template #buttons>
            <v-btn @click="closeDialog">{{ $t('common.cancel') }}</v-btn>
            <v-btn
                color="primary"
                variant="elevated"
                @click="saveData"
                :loading="saveLoading"
            >
                {{ $t('common.save') }}
            </v-btn>
        </template>
    </SignaloDialog>
</template>

<script>
export default {
    props: {
        dialogOpened: Boolean,
        item: null,
    },
    emits: ['close'],
    data() {
        return {
            name: this.item?.name || '',
            shift_schema_id: this.item?.shift_schema_id || null,
            saveLoading: false,
        };
    },
    methods: {
        closeDialog(shouldRefech = false, newCrew = null) {
            this.$emit('close', shouldRefech, newCrew);
        },
        async saveData() {
            await this.$refs.form.validate();
            if (!this.dataValid) return;
            this.saveLoading = true;
            let newCrew;
            try {
                const payload = {
                    name: this.name,
                    shift_schema_id: this.shift_schema_id,
                };
                if (this.item?.id !== undefined) {
                    newCrew = await this.axios.put(
                        `crews/${this.item.id}`,
                        payload
                    );
                } else {
                    newCrew = await this.axios.post('crews', payload);
                }
                this.closeDialog(true, newCrew?.data?.item);
                this.helpersStore.snackbarSaved();
            } catch (err) {
                if (err?.response?.status === 401) return;
                this.saveLoading = false;
            }
        },
    },

    computed: {
        required() {
            return [(v) => !!v || this.$t('common.fieldRequired')];
        },
    },
};
</script>
